/**
 * Detects whether the current document was prerendered (SSG) - i.e. the build
 * baked real markup into <div id="root"> - versus the plain SPA fallback whose
 * root is empty.
 *
 * Captured ONCE at module load, before React hydrates, because hydrateRoot
 * empties/owns #root immediately. Components read this synchronously so their
 * first client render matches the server render (no hydration mismatch).
 *
 * - Server (no window): treated as prerendered (we ARE the prerender pass).
 * - Client on a prerendered page: #root had children at load -> true.
 * - Client on the SPA fallback: #root empty -> false (normal client boot).
 */
export const isPrerendered: boolean =
  typeof document === 'undefined' ||
  (document.getElementById('root')?.hasChildNodes() ?? false)
